import { connect } from "react-redux";
import { ConnectSocket, DisconnectSocket } from "../../lib/socket";
import { useCallback, useEffect, useState } from "react";
import { PROVIDER_RAYTEAMS, SOCKET_EVENT_TYPE } from "../../constants/avatar";
import { AvatarAction } from "../../redux/actions/AvatarAction";

const WSRayTeams = ({ token, RefreshAvatar }) => {
  const [socket, setSocket] = useState(null);

  const genSocket = useCallback(async () => {
    const _socket = await ConnectSocket()
    setSocket(_socket);
  }, []);

  useEffect(() => {
    if (token) {
      genSocket();
    }
    return () => {
      DisconnectSocket();
      setSocket(null);
    }
  }, [token, genSocket]);

  useEffect(() => {
    if (socket && socket?.onmessage) {
      socket.onmessage = (msg) => {
        if (msg?.data === "pong") {
          return;
        }
        const data = JSON.parse(msg.data);
        if (data?.msg?.provider === PROVIDER_RAYTEAMS && data?.msg?.type) {
          switch (data.msg.type) {
            case SOCKET_EVENT_TYPE.PROGRESSING:
            case SOCKET_EVENT_TYPE.VIEW_READY:
              RefreshAvatar();
              break;
            case SOCKET_EVENT_TYPE.EXPIRED:
              console.log("SOCKET_EVENT_TYPE.EXPIRED", data);
              RefreshAvatar();
            break;
            default:
              break;
          }
        }
      };
      socket.onerror = () => {
        setTimeout(() => {
          genSocket();
        }, 3000);
      };
      socket.onclose = () => {
        setTimeout(() => {
          genSocket();
        }, 3000);
      };
    }
  }, [RefreshAvatar, socket, genSocket]);

  return <></>
}

const mapState = (state) => {
  const token = state.AuthReducer.token;
  return { token };
};
const mapDispatch = (dispatch) => ({
  RefreshAvatar: () => dispatch(AvatarAction.RefreshAvatar()),
});

export default connect(mapState, mapDispatch)(WSRayTeams);